import React from "react";

const Nav = ({ children }) => {
  return (
    <nav className="p-4">
      <ul className="flex space-x-2">{children}</ul>
    </nav>
  );
};

const NavItem = ({ isActive, children }) => {
  return (
    <li>
      <div
        className={`block cursor-pointer px-4 py-2 rounded-md capitalize ${
          isActive ? "bg-emerald-100 text-blue-700" : ""
        }`}
      >
        {children}
      </div>
    </li>
  );
};

const List = ({ children }) => {
  return <ul className="divide-y-2 divide-coolGray-100">{children}</ul>;
};

const ListItem = ({ product, setProductAndNavigate }) => {
  return (
    <article className="p-4 flex space-x-4">
      <img
        src={product.game_image}
        alt=""
        className="flex-none w-18 h-18 rounded-lg object-cover bg-gray-100"
        width="144"
        height="144"
      />
      <div className="min-w-0 relative flex-auto sm:pr-20 lg:pr-0 xl:pr-20">
        <h2 className="text-lg font-semibold text-black mb-0.5 capitalize ml-2">
          {product.name}
        </h2>
        <div className="flex flex-wrap text-sm font-medium">
          <div>
            <p
              className="font-light w-10/12"
              title={`${product.name} description`}
            >
              {product.game_description}
            </p>
          </div>
        </div>
        <div className="text-coolGray-600 ml-2">
          Max players per world:{" "}
          <span className="text-black font-semibold">
            {product.players_per_world}
          </span>
        </div>
        <div
          className="absolute top-0 right-0 rounded-full bg-blue-50 text-blue-900 px-2 py-0.5 flex items-center space-x-1"
          onClick={() => setProductAndNavigate(product.id, product.name)}
        >
          <span>select</span>
          <svg
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M14 5l7 7m0 0l-7 7m7-7H3"
            />
          </svg>
        </div>
      </div>
    </article>
  );
};

export { Nav, NavItem, List, ListItem };
